// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2nYzH","header":"Messages_header__2vu45"};